"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sidebar = void 0;
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
require("./Sidebar.scss");
var ContactBar_1 = require("./ContactBar");
var actions_1 = require("@app/features/new-packages/state/actions");
var selectors_1 = require("@app/features/pending-uploads/state/selectors");
var HaloSpinnerWithText_1 = require("@app/components/HaloSpinnerWithText");
var constants_1 = require("@app/shared/constants");
var Sidebar = /** @class */ (function (_super) {
    __extends(Sidebar, _super);
    function Sidebar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Sidebar.prototype.componentDidMount = function () {
        if (window.location.pathname !== constants_1.HOME_PATH) {
            this.props.onGetNewPackages(this.props.pageSize);
        }
    };
    Sidebar.prototype.render = function () {
        var _a = this.props, newPackagesCount = _a.newPackagesCount, activeUploadsCount = _a.activeUploadsCount;
        return (react_1.default.createElement("div", { className: "sidebar-dash" },
            react_1.default.createElement("div", { className: "sidebar-top" },
                react_1.default.createElement("div", { className: "tabs is-hidden-tablet is-hidden-desktop is-hidden-widescreen is-hidden-fullhd" },
                    react_1.default.createElement("ul", null,
                        react_1.default.createElement("li", { style: { position: 'relative' } },
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: "button is-large", to: "/dash", exact: true },
                                react_1.default.createElement("span", { className: "icon" },
                                    react_1.default.createElement("i", { className: "fas fa-meteor fa-fw" }))),
                            newPackagesCount > 0 &&
                                react_1.default.createElement("span", { className: "mobile-new-packages-count" }, newPackagesCount)),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: "button is-large", to: "/dash/packages/history" },
                                react_1.default.createElement("span", { className: "icon" },
                                    react_1.default.createElement("i", { className: "far fa-clock fa-fw" })))),
                        react_1.default.createElement("li", null,
                            react_1.default.createElement(react_router_dom_1.NavLink, { className: "button is-large", to: "/dash/packages/upload" },
                                react_1.default.createElement("span", { className: "icon" },
                                    react_1.default.createElement("i", { className: "fas fa-rocket fa-fw" })))))),
                react_1.default.createElement("div", { className: "is-hidden-mobile" },
                    react_1.default.createElement(react_router_dom_1.NavLink, { className: "button is-large is-fullwidth my-packages-button", to: "/dash", exact: true, activeClassName: "active" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-meteor fa-fw" })),
                        react_1.default.createElement("span", { className: "has-text-weight-bold" }, "Inbox"),
                        this.props.newPackagesCount > 0 &&
                            react_1.default.createElement("span", { className: "new-packages-count" }, newPackagesCount)),
                    react_1.default.createElement(react_router_dom_1.NavLink, { className: "button is-large is-fullwidth package-history-button", to: "/dash/packages/history", activeClassName: "active" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "far fa-clock fa-fw" })),
                        react_1.default.createElement("span", { className: "has-text-weight-bold" }, "History")),
                    react_1.default.createElement(react_router_dom_1.NavLink, { className: "button is-large is-fullwidth package-upload-button", to: "/dash/packages/upload", exact: true, activeClassName: "active" },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "fas fa-rocket fa-fw" })),
                        react_1.default.createElement("span", { className: "has-text-weight-bold" }, "Send"),
                        activeUploadsCount > 0 &&
                            react_1.default.createElement(HaloSpinnerWithText_1.HaloSpinnerWithText, { value: activeUploadsCount })))),
            react_1.default.createElement("div", { className: "sidebar-bottom is-hidden-mobile" },
                react_1.default.createElement(ContactBar_1.ContactBar, { asperaVersion: this.props.asperaVersion, openTermsModal: this.props.openTermsModal }))));
    };
    return Sidebar;
}(react_1.Component));
exports.Sidebar = Sidebar;
var mapStateToProps = function (store) {
    return {
        newPackagesCount: store.newPackages.totalCount,
        activeUploadsCount: selectors_1.getActiveUploadsCount(store)
    };
};
var mapDispatchToProps = {
    onGetNewPackages: actions_1.resetNewPackages
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps, null, { pure: false })(Sidebar);
